import React, { useCallback, useState } from "react";
import { VehiclesType } from "../../../../store/reducers/dashboard/vehicles/types/types";
import st from './chart.module.scss';
import ChartElement from "@pages/dashboard/vehiclesTypes/chart/components/chartElement";
import cn from "classnames";

type VehiclesTypesChartProps = {
	data: VehiclesType[]
}

const VehiclesTypesChart = ({ data }: VehiclesTypesChartProps) => {
	const [overflow, setOverflow] = useState(false)

	const wrapperRef = useCallback((node: HTMLElement | null) => {
		if (node && node.scrollHeight > node.clientHeight) setOverflow(true)
	}, [])

	return (
		<div className={cn(st['chart'], overflow && st['chart--overflow'])} ref={wrapperRef}>
			{data.map(type => <ChartElement type={type} key={type.unitType + `-vehicles`} />)}
		</div>
	)
}

export default VehiclesTypesChart;